module.exports = __webpack_public_path__ + "img/squishiland-land.a66c95fd.png";